export default __webpack_public_path__ + "static/media/logo_anap.974c3736.png";